import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import '../styles/pages/NotFound.scss';

const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://www.promocionalesenstock.com';

const NotFound = () => {
  const pageTitle = '404 – Página no encontrada | Promocionales en Stock';
  const pageDescription = 'Lo sentimos, la página que buscas no existe o ha sido movida. Regresa al inicio o explora nuestras categorías.';
  const canonicalUrl = '/404';
  const additionalMeta = [
    { name: 'robots', content: 'noindex,follow' },
  ];

  return (
    <>
      {/* SEO para 404: noindex, follow */}
      <Seo
        title={pageTitle}
        description={pageDescription}
        canonicalUrl={canonicalUrl}
        prevPageUrl={null}
        nextPageUrl={null}
        ogImage="/images/og-default.jpg"
        ogType="website"
        jsonLd={null}
        additionalMeta={additionalMeta}
        siteUrl={SITE_URL}
      />

      <div className="NotFound container">
        <div className="NotFound__content">
          <h1 className="NotFound__title">404</h1>
          <h2 className="NotFound__subtitle">Ups, página no encontrada</h2>
          <p className="NotFound__text">
            Lo sentimos, la página que buscas no existe o ha sido movida.
          </p>
          <div className="NotFound__actions">
            <Link to="/" className="btn btn-primary mr-5">
              Volver al inicio
            </Link>
            <Link to="/categorias" className="NotFound__link">
              Ver todas las categorías
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
